module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"feeDetail":"Detalle de tu cuota"},"pe":{"feeDetail":"Detalle de tu cuota"},"br":{"feeDetail":"Detalhe da parcela"}}')
  delete Component.options._Ctor
}
